import api from "../../api/index.js";

const state = {};

const getters = {};

const actions = {
  BankDel({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.post(
        "/MemberBankInfo/Delete",
        payload,
        (res) => {
          resolve(res);
        },
        (err) => {
          reject(err);
        }
      );
    });
  },
  GetBankList({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.get(
        "/MemberBankInfo/List",
        payload,
        (res) => {
          resolve(res);
        },
        (err) => {
          reject(err);
        }
      );
    });
  },
  UpdateMemberBankInfo({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.post(
        "/MemberBankInfo/Post",
        payload,
        (res) => {
          resolve(res);
        },
        (err) => {
          reject(err);
        }
      );
    });
  },
};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations,
};
